import { faTag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Tag } from "../state/types";
import { tagBg } from "./tagColors";
import { TagsPopover } from "./TagsPopover";

type Props = {
  parcel: { id: number; tags: Tag[] };
  workspaceId: number;
  variant?: "compact" | "full";
};

export const TagButton = ({ parcel, workspaceId, variant = "compact" }: Props) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const popover = open ? (
    <TagsPopover
      parcel={parcel}
      workspaceId={workspaceId}
      anchorRef={anchorRef}
      onClose={() => setOpen(false)}
    />
  ) : null;

  if (variant === "full") {
    return (
      <>
        <button
          ref={anchorRef}
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-bold bg-gray-100 hover:bg-gray-200 text-gray-700"
        >
          <FontAwesomeIcon icon={faTag} className="w-3.5 h-3.5" />
          {parcel.tags.length > 0
            ? `${parcel.tags.length} label${parcel.tags.length === 1 ? "" : "s"}`
            : "Labels"}
        </button>
        {popover}
      </>
    );
  }

  return (
    <>
      <button
        ref={anchorRef}
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-gray-400 hover:text-gray-700 px-1 py-0.5 rounded"
        title="Labels"
        aria-label="Labels"
      >
        {parcel.tags.length === 0 ? (
          <FontAwesomeIcon icon={faTag} className="w-2.5 h-2.5" />
        ) : (
          <span className="flex items-center gap-0.5">
            {parcel.tags.slice(0, 4).map((tag) => (
              <span key={tag.id} className={`block w-2 h-2 rounded-full ${tagBg[tag.color]}`} />
            ))}
            {parcel.tags.length > 4 && (
              <span className="text-[9px] leading-none">+{parcel.tags.length - 4}</span>
            )}
          </span>
        )}
      </button>
      {popover}
    </>
  );
};
